var map = {
	"./configure-sso-de.html": 1480,
	"./configure-sso-en.html": 1481,
	"./configure-sso-es.html": 1482,
	"./configure-sso-fr.html": 1483,
	"./configure-sso-ja.html": 1484,
	"./configure-sso-pt.html": 1485,
	"./configure-sso-zh.html": 1486
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1479;


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/manage-application/integration-developers/configure-sso ^\.\/configure\-sso\-.*\.html$
// module id = 1479
// module chunks = 0